import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from "./components/App";
import {setupStore} from "./store";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import './index.css';
import "yet-another-react-lightbox/styles.css";

import '@fontsource/inter/cyrillic-400.css';
import '@fontsource/inter/cyrillic-600.css';
import '@fontsource/inter/cyrillic-700.css';

import '@fontsource/ibm-plex-sans/cyrillic-400.css';
import '@fontsource/ibm-plex-sans/cyrillic-500.css';
import '@fontsource/ibm-plex-sans/cyrillic-600.css';
import '@fontsource/ibm-plex-sans/cyrillic-700.css';
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-sans/latin-700.css';

import '@fontsource/courier-prime/400.css';
import '@fontsource/courier-prime/700.css';
import {injectStore} from "./api";
import ErrorBoundary from "./components/common/ErrorBoundary";
import {setupGlobalErrorHandlers} from "./utils/setupGlobalErrorHandlers";

// Сеть безопасности для непойманных async-ошибок (промисы, WS-колбэки).
// Подключаем до рендера, чтобы перехватывать ошибки с самого старта.
setupGlobalErrorHandlers();

const store = setupStore();
injectStore(store);
// Dev-шов для e2e-проверок (Claude in Chrome): доступ к стору из консоли.
// В production-сборку не попадает (guard по NODE_ENV).
if (process.env.NODE_ENV === 'development') (window as any).__appStore = store;

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                {/* Корневой ErrorBoundary — последний рубеж от белого экрана,
                    если упадёт рендер самого App или провайдеров внутри него. */}
                <ErrorBoundary>
                    <App/>
                </ErrorBoundary>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>
);

// Service worker — только системные уведомления (S10, `public/sw.js`): на Android
// Chrome `new Notification()` не работает. Не зарегистрировался — старт не ломаем.
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('Service worker не зарегистрирован', e));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
